import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            每日精选最热吃瓜内容，为你呈现51吃瓜与91吃瓜最新资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}